// import { useEffect, useState } from 'react';

// import { useLoading } from '@/hooks/use-loading.hook';
// import { getLogger } from '@/app/(main)/_components/apm-logger/store/get-apm-logger';
// import { getTermsOfUse } from '@/app/(main)/(pages)/(institucional)/termos-de-uso/_services/terms-of-use.service';
// import { getPrivacyPolicy } from '@/app/(main)/(pages)/(institucional)/politica-de-privacidade/_services/privacy-policy.service';

export const useTermsAndPolicy = () => {
  // const logger = getLogger();
  // const { startLoading, stopLoading, isLoading } = useLoading();
  // const [terms, setTerms] = useState<string>('');
  // const [policy, setPolicy] = useState<string>('');

  // useEffect(() => {
  //   async function fetchTerms() {
  //     try {
  //       startLoading();
  //       const responseTerms = await getTermsOfUse();
  //       const responsePolicy = await getPrivacyPolicy();
  //       setTerms(responseTerms?.terms || '');
  //       setPolicy(responsePolicy?.policy || '');
  //     } catch (err) {
  //       logger.error('Error fetching terms and policy:', {}, err);
  //     } finally {
  //       stopLoading();
  //     }
  //   }

  //   if (!terms) {
  //     fetchTerms();
  //   }
  // }, [terms]);

  // return { terms, policy, isLoading };
  return { terms: '', policy: '', isLoading: false };
};
